import ModernSearch from './ModernSearch'

export default ModernSearch
